import { pdfTypeApi } from "../../api";

const PdfTypeService = {
  fetchDropdown: async () => {
    const response = await pdfTypeApi.fetchCustom("/dropdown");
    return response.data;
  },
};

export default PdfTypeService;
